var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCommentSolid = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.25 1.5C3.52065 1.5 2.82118 1.78973 2.30546 2.30546C1.78973 2.82118 1.5 3.52065 1.5 4.25V21C1.5 21.299 1.67754 21.5694 1.95186 21.6882C2.22617 21.807 2.54486 21.7516 2.76296 21.5471L6.54659 17.9999H19.7676C20.4969 17.9999 21.1964 17.7102 21.7121 17.1945C22.2278 16.6788 22.5176 15.9793 22.5176 15.2499V4.25C22.5176 3.52066 22.2278 2.82118 21.7121 2.30546C21.1964 1.78973 20.4969 1.5 19.7676 1.5H4.25ZM6.75 6C6.33579 6 6 6.33579 6 6.75C6 7.16421 6.33579 7.5 6.75 7.5H17.25C17.6642 7.5 18 7.16421 18 6.75C18 6.33579 17.6642 6 17.25 6H6.75ZM6 9.75C6 9.33579 6.33579 9 6.75 9H17.25C17.6642 9 18 9.33579 18 9.75C18 10.1642 17.6642 10.5 17.25 10.5H6.75C6.33579 10.5 6 10.1642 6 9.75ZM6.75 12C6.33579 12 6 12.3358 6 12.75C6 13.1642 6.33579 13.5 6.75 13.5H11.25C11.6642 13.5 12 13.1642 12 12.75C12 12.3358 11.6642 12 11.25 12H6.75Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCommentSolid);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/comment-solid.f44c6f1e3d51214dfc2fe0d8dddb8319.svg";